import React, { useEffect, useState } from 'react';
import LoginUiComponent from '../../components/loginUiComponent/loginUiComponent';
import { Button, PasswordInput } from '@mantine/core';
import { ChannelkartNetworkPost } from '../../services/networkService';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { eventEnum, logEvent } from '../../services/eventsService/eventService';
import { getLoginPolicyandTwoFactorAuthState, getLoginUIConfig, logoutUser } from '../../services/authenticationService';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loader } from '../../components/loader/Loader';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

export default function ChangePassword() {
    const CUR_COMPONENT = "LogInAndChangePassword"
    const { translate } = usePortalTranslation();
    const [loader , setLoader] = useState<boolean>(true);
    const [loginUIConfig, setLoginUIConfig] = useState(null);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const handleCurrentPasswordChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setCurrentPassword(event.target.value);
    };

    const handleNewPasswordChange = (event: { target: { value: any; }; }) => {
        const newPasswordValue = event.target.value;
        setNewPassword(newPasswordValue);
    };

    const handleConfirmPasswordChange = (event: { target: { value: any; }; }) => {
        const confirmPasswordValue = event.target.value;
        setConfirmPassword(confirmPasswordValue);
    };

    const handleSubmit = async (event: { preventDefault: () => void; }) => {
        event.preventDefault();
        if (newPassword !== confirmPassword) {
            openPopup('Error', 'Passwords do not match')
        } else {
            if(newPassword.trim().length===0){
                openPopup('Error', 'Password can not be empty spaces');
                return;
            }
            try {
                const authContext = localStorage.getItem("authContext");
                const loginId = authContext ? JSON.parse(authContext).user.loginId : null;
                const reqBody = {
                    "loginId": loginId,
                    "oldPassword": currentPassword,
                    "newPassword": newPassword
                }
                const response = await ChannelkartNetworkPost("/changePassword", reqBody)
                if (response.status == 200) {
                    logEvent(eventEnum.logout, { feature_name: "logout" })
                    logoutUser()
                } else {
                    openPopup('Error', response.data.message)
                }
            } catch (error: any) {
                console.log(error)
                openPopup('Error', error.response.data.message)
            }
        }

        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
    };

    useEffect(() => {
        const fetchLoginPolicy = async () => {
          try {
            setLoader(true);
            const { loginUIConfig } = await getLoginUIConfig();
            setLoginUIConfig(loginUIConfig);
            setLoader(false);
          } catch (error) {
            setLoader(false);
            console.error('Error fetching login policy:', error);
          }
        };
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        if (mediaQuery.matches) {
          setLoader(true);
          fetchLoginPolicy();
        }else{
          setLoader(true);
          setLoginUIConfig(null);
          setLoader(false);
        }
        const handleResize = async() => {
          if (mediaQuery.matches) {
            setLoader(true);
            await fetchLoginPolicy();
          }else{
            setLoader(true);
            setLoginUIConfig(null);
            setLoader(false);
          }
        };
        mediaQuery.addEventListener('change', handleResize);
        return () => {
          mediaQuery.removeEventListener('change', handleResize);
        };
      }, []);

    return (
        <>
          {
            loader ? <Loader /> : <LoginUiComponent loginUIConfig={loginUIConfig} allow={true}>
            <form style={{ gap: "10px" }} autoComplete="off" className="loginInputs" onSubmit={handleSubmit}>
                <PasswordInput
                    style={{ width: "70%" }}
                    id='currentPasswordInput'
                    placeholder={translate(TranslationEnum.login_and_change_password,"Current Password")}
                    value={currentPassword}
                    autoComplete="off"
                    readOnly
                    onFocus={(e) => e.target.removeAttribute("readOnly")}
                    onChange={handleCurrentPasswordChange}
                />
                <PasswordInput
                    style={{ width: "70%" }}
                    id='newPasswordInput'
                    placeholder={translate(TranslationEnum.login_and_change_password,"New Password")}
                    value={newPassword}
                    autoComplete="off"
                    readOnly
                    onFocus={(e) => e.target.removeAttribute("readOnly")}
                    onChange={handleNewPasswordChange}
                />
                <PasswordInput
                    style={{ width: "70%" }}
                    id='confirmPasswordInput'
                    placeholder={translate(TranslationEnum.login_and_change_password,"Confirm Password")}
                    value={confirmPassword}
                    autoComplete="off"
                    readOnly
                    onFocus={(e) => e.target.removeAttribute("readOnly")}
                    onChange={handleConfirmPasswordChange}
                />

                <Button style={loginUIConfig ? { backgroundColor:"#ED1229" } : {}} type="submit">{translate(TranslationEnum.login_and_change_password,"Submit")}</Button>
                <div onClick={() => {
                    window.history.back();
                }}>
                    <FontAwesomeIcon style={{ color: loginUIConfig ? "#ED1229" : "white" }} icon={faArrowLeft}/>
                </div>

            </form>
        </LoginUiComponent>}
        </>
    );
}
